import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/noAuthApiClient';
export const fetchCaptionUrls = videoId => http.get(`video/v1/public/${videoId}/subtitles`, {
  withCredentials: false,
  query: {
    portalId: PortalIdParser.get()
  }
});